import script from "./AppDndList.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppDndList.vue?vue&type=script&lang=ts&setup=true"

import "./AppDndList.vue?vue&type=style&index=0&id=58ac8886&scoped=true&lang=scss"
script.__scopeId = "data-v-58ac8886"

export default script
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItem,QItemSection,QIcon});
